"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListingImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _map = _interopRequireDefault(require("lodash/map"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var defaultLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto:eco,f_auto,fl_progressive:steep';
var cloudinaryLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto,fl_progressive:steep';
var ListingImage = exports.ListingImage = /*#__PURE__*/function (_React$Component) {
  _inherits(ListingImage, _React$Component);
  function ListingImage(props) {
    var _this;
    _classCallCheck(this, ListingImage);
    _this = _callSuper(this, ListingImage, [props]);
    _this.imageHasLoaded = _this.imageHasLoaded.bind(_assertThisInitialized(_this));
    _this.checkImg = _this.checkImg.bind(_assertThisInitialized(_this));
    _this.srcSet = _this.srcSet.bind(_assertThisInitialized(_this));
    _this.renderImgUrl = _this.renderImgUrl.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ListingImage, [{
    key: "imageHasLoaded",
    value: function imageHasLoaded() {
      this.props.onPicLoad();
    }
  }, {
    key: "checkImg",
    value: function checkImg() {
      var _this$props = this.props,
        alt = _this$props.alt,
        defaultWidth = _this$props.defaultWidth,
        defaultHeight = _this$props.defaultHeight,
        imgId = _this$props.imgId,
        sizes = _this$props.sizes,
        style = _this$props.style,
        id = _this$props.id,
        onPicLoad = _this$props.onPicLoad;
      var imgs = this.srcSet(imgId);
      var picLoadCB = function picLoadCB() {
        this.imageHasLoaded();
      }.bind(this);
      var extraSettings = {
        className: style,
        sizes: sizes,
        src: imgId ? "".concat(defaultLink, ",w_").concat(defaultWidth.toFixed(0), ",h_").concat(defaultHeight.toFixed(0), "/").concat(imgId) : '/web-templates/assets/images/listing-placeholder.svg?v=rb',
        itemProp: 'image',
        id: id
      };
      if ((0, _isFunction.default)(onPicLoad)) {
        (0, _merge.default)(extraSettings, {
          onLoad: picLoadCB
        });
      }
      return /*#__PURE__*/_react.default.createElement("img", _extends({
        alt: alt,
        srcSet: imgs
      }, extraSettings));
    }
  }, {
    key: "srcSet",
    value: function srcSet(id) {
      var _this2 = this;
      var _this$props2 = this.props,
        height = _this$props2.height,
        widths = _this$props2.widths,
        addTransform = _this$props2.addTransform;
      var srcSetArray = (0, _map.default)(widths, function (width) {
        var calcHeight = height ? height : width / _this2.props.ratio;
        calcHeight = calcHeight.toFixed(0);
        return "".concat(_this2.renderImgUrl(id, width, calcHeight, addTransform), " ").concat(width, "w");
      });
      return srcSetArray.toString();
    }
  }, {
    key: "renderImgUrl",
    value: function renderImgUrl(imgId, width, height, addTransform) {
      var dpr = this.props.dpr;
      var img = imgId ? "".concat(cloudinaryLink, ",dpr_").concat(dpr || 2.0, ",w_").concat(width, ",h_").concat(height, "/").concat(addTransform ? addTransform : '').concat(imgId) : '/web-templates/assets/images/listing-placeholder.svg?v=rb';
      return img;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.containerStyle || ''
      }, this.checkImg());
    }
  }]);
  return ListingImage;
}(_react.default.Component);
ListingImage.propTypes = {
  alt: _propTypes.default.string,
  imgId: _propTypes.default.string.isRequired,
  ratio: _propTypes.default.number,
  defaultWidth: _propTypes.default.number.isRequired,
  defaultHeight: _propTypes.default.number.isRequired,
  widths: _propTypes.default.array.isRequired,
  height: _propTypes.default.number,
  style: _propTypes.default.string,
  sizes: _propTypes.default.string,
  containerStyle: _propTypes.default.string,
  id: _propTypes.default.string,
  onPicLoad: _propTypes.default.object
};